import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import Main from "./main";
import "./css/index.css";
import { initializeAnalytics } from './utils/analytics';

initializeAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Main/>
);
reportWebVitals();
